import React from 'react';

export default function MilitaryTrainingCreditModalContent() {
  return (
    <p>
      Does the school offer postsecondary credit for experiences and military
      training?
    </p>
  );
}
